"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDepartures = exports.almatyDeparture = exports.moscowDeparture = exports.defaultCountry = exports.supportedCountries = void 0;
/**
 * Доступные на фронте страны
 */
exports.supportedCountries = [
    'ru',
    'kz',
    'by',
    'tr',
    'az',
    'am',
    'kg',
    'uz',
    'lv',
    'lt',
    'ro',
    'ee'
];
/**
 * Дефолтное значение страны (если не передано)
 */
exports.defaultCountry = 'ru';
exports.moscowDeparture = {
    id: 213,
    nameEn: "Moscow",
    nameRu: "Москва",
    nameRuForm2: "Москвы",
};
exports.almatyDeparture = {
    id: 162,
    nameEn: "Almaty",
    nameRu: "Алматы",
    nameRuForm2: "Алматы",
};
/**
 * Дефолтные города вылета
 */
exports.defaultDepartures = new Map([
    ['ru', exports.moscowDeparture],
    ['kz', exports.almatyDeparture],
]);
